import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { defaultContacts } from "./AddFriends.web";
import React from 'react';
// Customizable Area Start

// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}


interface S {
  // Customizable Area Start
  activeTab: string;
  selectedCardId: string | null;
  searchTerm: string;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  // Customizable Area End
}

export default class AddFriendsController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  contactRefs: Record<string, React.RefObject<HTMLDivElement>> = {};
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.handleCardClick = this.handleCardClick.bind(this);

    // Customizable Area Start
    defaultContacts.forEach(c => {
      const L = c.name.charAt(0).toUpperCase();
      if (!this.contactRefs[L]) {
        this.contactRefs[L] = React.createRef<HTMLDivElement>();
      }
    });
    // Customizable Area End
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.NavigationPayLoadMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      activeTab: "Connections",
      selectedCardId: null,
      searchTerm: "",
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.showNavigationData(message)
    // Customizable Area End
  }

  // Customizable Area Start
  alphabetList = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');

  showNavigationData = (message: Message) => {
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      let data = message.getData(getName(MessageEnum.NavigationPayLoadMessage))
      this.setState({
        searchTerm: data.searchTerm,
      })
    }
  };

  componentDidUpdate(prevProps: Props) {
    this.handleSearchFromProps();
  }

  handleSearchFromProps() {
    if (this.state.searchTerm) {
      this.handleSearch(this.state.searchTerm);
    }
  }

  handleSearch = (searchTerm: string) => {
    const foundContact = defaultContacts.find(
      (contact) =>
        contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.location.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (foundContact) {
      const L = foundContact.name.charAt(0).toUpperCase();
      const ref = this.contactRefs[L];
      if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      this.setState({
        searchTerm: ""
      })
    }
  };

  handleFavoriteToggle = (contactId: string) => {
    const updatedContacts = defaultContacts.map(contact => {
      if (contact.id === contactId) {
        return { ...contact, isFavorite: !contact.isFavorite };
      }
      return contact;
    });

    defaultContacts.forEach((contact, index) => {
      if (contact.id === contactId) {
        defaultContacts[index] = updatedContacts.find(c => c.id === contactId) || contact;
      }
    });

    this.forceUpdate();
  };

  getDarkerColor = (hexColor: string, darknessFactor: number) => {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    const darkerR = Math.max(0, r - r * darknessFactor);
    const darkerG = Math.max(0, g - g * darknessFactor);
    const darkerB = Math.max(0, b - b * darknessFactor);

    return `${darkerR}, ${darkerG}, ${darkerB}`;
  }

  handleAlphabetClick = (letter: string) => {
    const ref = this.contactRefs[letter];
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  handleTabClick = (tab: string) => {
    this.setState({
      activeTab: tab,
      selectedCardId: null
    }, () => {
      let topContact;
      if (tab === "Connections") {
        const sortedContacts = [...defaultContacts].sort((a, b) => a.name.localeCompare(b.name));
        topContact = sortedContacts.length > 0 ? sortedContacts[0] : null;
      } else if (tab === "Favourites") {
        const favourites = [...defaultContacts].filter(contact => contact.isFavorite);
        favourites.sort((a, b) => a.name.localeCompare(b.name));
        const sortedFavourites = favourites;
        topContact = sortedFavourites.length > 0 ? sortedFavourites[0] : null;
      }

      if (topContact) {
        const firstLetter = topContact.name.charAt(0).toUpperCase();
        const ref = this.contactRefs[firstLetter];
        if (ref && ref.current) {
          ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  };

  handleCardClick = (cardId: string) => {
    if (this.state.selectedCardId === cardId) {
      this.setState({ selectedCardId: null });
    } else {
      this.setState({ selectedCardId: cardId });
    }
  };
  // Customizable Area End
}
